import {useMutation} from "react-query";
import {UpdateGroupPermissionCommand} from "../../models/group";
import groupService from "../../services/GroupService";

export default function useUpdateGroupPermission() {
   return useMutation((request: UpdateGroupPermissionCommand) => groupService.updatePermission(request));
}